import {
  CommonFilterEnum,
  ElasticsearchFilterTypeEnum,
  ContentFilterEnum,
  ReportRequestTypeEnum,
  ContentVersionLogSortFieldEnum,
  SortOrderEnum,
  RelatedUserFieldEnum
} from '@lyearn-team/reporting-library';

export default async function fetchContentVersions(
  reportingLibrary,
  contentId,
  pageInfo,
  companyId,
  includes = {}
) {
  try {
    const ReportParams = { filters: {} };
    const contentVersionLogFilters = [
      {
        name: ContentFilterEnum.CONTENT_ID,
        type: ElasticsearchFilterTypeEnum.MUST,
        values: [contentId]
      }
    ];

    ReportParams.filters.contentVersionLogFilters = contentVersionLogFilters;

    if (pageInfo.type === ReportRequestTypeEnum.PAGINATED) {
      ReportParams.requestType = ReportRequestTypeEnum.PAGINATED;
      ReportParams.from = pageInfo.from;
      ReportParams.size = pageInfo.size;
    } else {
      ReportParams.requestType = ReportRequestTypeEnum.ALL;
    }

    const SortParams = [
      {
        field: ContentVersionLogSortFieldEnum.CREATED_AT,
        order: SortOrderEnum.DESCENDING
      }
    ];

    const ReportProjection = {};
    if (includes.learner) {
      // companyId is compulsory here
      if (!companyId) {
        throw new Error(
          'companyId is compulsory when querying learnersCount inside contentVersionLog'
        );
      }
      const stateFilters = [
        {
          name: CommonFilterEnum.COMPANY_ID,
          type: ElasticsearchFilterTypeEnum.MUST,
          values: [companyId]
        }
      ];
      ReportParams.filters.stateFilters = stateFilters;

      ReportProjection.contentVersionLogProjection = {
        custom: ['learnersCount']
      };
    }
    if (includes.publisher) {
      ReportProjection.relatedUserProjection = [RelatedUserFieldEnum.CONTENT_PUBLISHER];
    }

    const reportingLibraryParams = {
      ReportParams,
      SortParams,
      ReportProjection
    };

    return reportingLibrary.getContentVersionLogReports(reportingLibraryParams);
  } catch (e) {
    console.log('Error in fetching versions of content', contentId);
    console.log(e);
    e.name = 'ERROR_FETCHING_VERSIONS';
    window.bugsnagClient && window.bugsnagClient.notify(e);
    throw e;
  }
}
